import { Button, Checkbox, FormLabel } from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { useTaskContext } from "../context";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { taskOperationsList } from "../constants/task.constants";
import { addTaskApi } from "API/apis/task/addTask";
import dayjs from "configs/dayjs.config";

import { SearchUsers } from "components/SearchSelect/SearchUsers";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";
import { VoiceFormFiller } from "components/AI/VoiceFormFiller";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { searchUserApi } from "API/apis/search/searchUsers";

const initialUserDetail = {
  name: "",
  dept: "",
  subDept: "",
  userId: "",
};
const initialState = {
  docType: 1,
  docId: 0,
  taskDetails: "",
  deadline: new Date(),
  taskTo: { name: "rohit", dept: "", subDept: "", userId: "" },
  companyId: 0,
};
export const AddTask = () => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const { setCurrentOperationPage, setReloadRequired } = useTaskContext();
  const [formData, setFormData] = useState(initialState);
  const [selectedTaskByUser, setSelectedTaskByUser] =
    useState(initialUserDetail);
  const [selectedTaskToUser, setSelectedTaskToUser] =
    useState(initialUserDetail);
  const [isDelegateTask, setIsDelegateTask] = useState(false);
  const [formDataFromVoice, setFormDataFromVoice] = useState();
  useEffect(() => {
    if (formDataFromVoice) {
      setFormData((prev) => ({
        ...prev,
        taskDetails: formDataFromVoice.taskDetails,
        taskDescription: formDataFromVoice.taskDescription,
        deadline: formDataFromVoice.deadline,
      }));
      const fetchUserDetails = async () => {
        if (!formDataFromVoice.user) return;
        const { data, status } = await searchUserApi(formDataFromVoice.user);
        if (status !== 200) {
          return;
        }
        setSelectedTaskToUser(data[0]);
      };

      fetchUserDetails();
    }
  }, [formDataFromVoice]);
  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        deadline: newValue.toDate(),
      });
    }
  };
  const handleDelegationCheckboxClick = (newValue) => {
    setIsDelegateTask(newValue);
    setSelectedTaskByUser(initialUserDetail);
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      docType: 1,
      [e.target.name]: e.target.value,
    });
  };
  const handleAddNewTaskSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dayjs().subtract(1, "day") > formData.deadline) {
        throw new Error("Older dates are not allowed");
      }
      setIsLoading(true);
      const { data, status } = await addTaskApi({
        ...formData,
        taskTo: selectedTaskToUser?.userId || "",
        taskBy: selectedTaskByUser?.userId || "",
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData(initialState);
      setReloadRequired(true);
      setCurrentOperationPage(taskOperationsList.listTask);
      setSuccess(data?.message);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };
  return (
    <>
      <FlexBox justifyContent={"space-between"} alignItems="center" mb={2}>
        <PageTitle pageName={pageName.task.newTask} />
        <FlexBox gap={2}>
          {/* <VoiceFormFiller setFormDataFromVoice={setFormDataFromVoice} /> */}
          {/* <TaskTopBanner
            buttonType="back"
            taskOperationsParam={taskOperationsList.listTask}
          /> */}
        </FlexBox>
      </FlexBox>
      <form onSubmit={handleAddNewTaskSubmit}>
        <TextFieldWrapper
          multiline
          id="taskDetails"
          name="taskDetails"
          label="Task Detail"
          variant="outlined"
          value={formData.taskDetails}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          multiline
          id="taskDescription"
          name="taskDescription"
          label="Task Description"
          variant="outlined"
          value={formData.taskDescription}
          rows={5}
          fullWidth
          required
          onChange={handleChange}
        />
        <FormControlWrapper fullWidth>
          <FormLabel>
            Do you want to assign the task on behalf of someone else?
            <Checkbox
              aria-label="Do you want to assign the task on behalf of someone else?"
              value={isDelegateTask}
              onChange={() => handleDelegationCheckboxClick(!isDelegateTask)}
            />
          </FormLabel>
          {isDelegateTask && (
            <SearchUsers
              label="Assign By"
              handleUserSelection={setSelectedTaskByUser}
              selectedUser={selectedTaskByUser}
            />
          )}
        </FormControlWrapper>
        <FormControlWrapper fullWidth>
          <SearchUsers
            label="Assign To"
            handleUserSelection={setSelectedTaskToUser}
            selectedUser={selectedTaskToUser}
          />
        </FormControlWrapper>
        <TextFieldWrapper
          id="alertBeforeDays"
          name="alertBeforeDays"
          label="Alert Before Days"
          variant="outlined"
          value={formData.alertBeforeDays}
          fullWidth
          inputProps={{ min: 1 }}
          required
          onChange={handleChange}
        />
        <FormControlWrapper fullWidth>
          <DatePickerWrapper
            label="Deadline"
            value={dayjs(formData.deadline)}
            onChange={(newValue) => handleDeliveryDateChange(dayjs(newValue))}
          />
        </FormControlWrapper>
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
